import * as React from 'react';
import { Icons, TooltipIcon } from 'src/components/';
import styled from 'styled-components';

export interface ITableRowChildrenProps {
  preventClosing: (val: boolean) => void;
  closeRow: () => void;
}

export type ITableRowValue =
  | string
  | boolean
  | number
  | React.ReactChild
  | [string, string];

interface ITableRowProps {
  key?: number;
  heading?: boolean;
  values: ITableRowValue[];
  children?: (props: ITableRowChildrenProps) => React.ReactChild;
  onDirtyChange?: (dirty: boolean) => void;
  className?: string;
  noEditForm?: boolean;
}
interface ITableRowState {
  open: boolean;
  preventClosing: boolean;
}

const StyledTableRow = styled.div<{ heading: boolean }>`
  background-color: ${(props) =>
    props.heading ? props.theme.primary : '#fff'};
`;
const StyledEditButton = styled.button<{ open: boolean }>`
  color: ${(props) =>
    props.open ? props.theme.primary : props.theme.secondary};
  &:hover {
    color: ${(props) => props.theme.primary};
  }
`;

class TableRow extends React.Component<ITableRowProps, ITableRowState> {
  state = {
    open: false,
    preventClosing: false,
  };

  toggleOpen = (isOpen?: boolean) => {
    if (
      this.state.preventClosing &&
      !window.confirm('Unsaved changes in the form. Close?')
    ) {
      return;
    }
    if (this.props.onDirtyChange) {
      this.props.onDirtyChange(false);
    }
    this.setState((state) => ({
      open: isOpen || !state.open,
      preventClosing: false,
    }));
  };

  preventClosing = (dirty: boolean) => {
    if (this.props.onDirtyChange) {
      this.props.onDirtyChange(dirty);
    }
    this.setState({ preventClosing: dirty });
  };

  getValue(value: ITableRowValue, isHeading?: boolean) {
    if (typeof value === 'boolean') {
      return String(value);
    }
    if (Array.isArray(value)) {
      return isHeading ? (
        <div className="flex">
          <span className="flex-1 pt-1 mr-2">{value[0]}</span>
          <TooltipIcon secondary={true} width="w-64" text={value[1]} />
        </div>
      ) : (
        value[0]
      );
    }
    return value;
  }

  renderEditButton = () => {
    if (this.props.heading) {
      return <div className="w-16" />;
    } else {
      return (
        <div className="w-16 flex">
          <StyledEditButton
            onClick={this.toggleOpen.bind(null, undefined)}
            className={`flex-1 p-3 bg-white focus:outline-none`}
            open={this.state.open}
          >
            <Icons.Edit />
          </StyledEditButton>
        </div>
      );
    }
  };

  render() {
    const { heading, values, children, className, noEditForm } = this.props;
    const { open } = this.state;

    return (
      <div
        className={`transition-shadow break-words ${open ? 'shadow-lg' : ''} ${
          className || ''
        }`}
      >
        <div
          className={`flex ${
            !heading && open
              ? 'border-b-3 border-grey-dark sticky z-10 pin-t pin-l'
              : ''
          } ${!heading && !open ? 'border-b border-grey' : ''}`}
        >
          {values.map((value, i) => (
            <StyledTableRow
              key={i}
              className={`flex-1 p-3 border-r border-grey bg-white word-break ${
                heading ? 'text-white text-xl' : ''
              }`}
              heading={Boolean(heading)}
            >
              {this.getValue(value, heading)}
            </StyledTableRow>
          ))}

          {!noEditForm && this.renderEditButton()}
        </div>
        {open &&
          children &&
          children({
            preventClosing: this.preventClosing,
            closeRow: this.toggleOpen.bind(null, false),
          })}
      </div>
    );
  }
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/views/Admin/components/TableRow.tsx